export const ACCEPTED_IMAGE_FORMAT = ['image/jpeg', 'image/png'];
export const ACCEPTED_COVER_IMAGE_FORMAT = [
  ...ACCEPTED_IMAGE_FORMAT,
  'image/gif',
];
export const FILE_SIZE_LIMIT = 96 * 1024 * 1024; // 100 Mo

// Free plan limit
export const FILE_SIZE_LIMIT_RESTRICTED = 5 * 1024 * 1024; // 5 Mo
